import React from 'react'

import { NewUserPage } from '.'
import { ProfDashboard, ProfStudents } from '../components'

import { InternalContent } from './styles'

const ProfessorsPage = ({ part }: { part: string }) => {
  return (
    <InternalContent style={{ overflowY: 'scroll' }}>
      {part === 'dashboard' ? (
        <ProfDashboard />
      ) : part === 'admin-new-user' ? (
        // <AdminNewUser />
        <NewUserPage />
      ) : (
        <ProfStudents part={part} />
      )}
    </InternalContent>
  )
}

export default ProfessorsPage
